module.exports = __webpack_public_path__ + "static/img/fenzu.c922083.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fenzu.png
// module id = mU4P
// module chunks = 3